/**
 * Centralized asset paths for the entire application
 * All images, logos, icons, and GIFs should be referenced from here
 */

import Footer from '#app/components/footer.js'

export const assets = {
	hero: {
		banner: '/img/herobannernew.png',
		landlord: '/img/landlord-hero-image.png',
	},
	auth: {
		tenant: {
			backgroundImage: '/img/auth-page-image.webp',
			heroText: {
				line1: 'Where',
				line2: 'Renting Feels Easy',
			},
		},
		landlord: {
			backgroundImage: '/img/landlord-hero-image.png',
			heroText: {
				line1: 'Built For Landlords,',
				line2: 'By Landlords',
			},
		},
	},
	screening: {
		consentBackground: '/img/consent-background.png',
		consentBackground2: '/img/consent-background2.png',
	},
	logos: {
		/** Primary brand wordmark (web, email, PDF). */
		main: '/img/TrueTenant.png',
		marquee: [
			'/img/landlords/marque_logo2.png',
			'/img/landlords/marque_logo3.png',
			'/img/landlords/marque_logo4.png',
		],
		flinksPartnerLogos: [
			'/img/landlords/673f5f1f41f68502e8b7a0c7_clients_peoples-group.avif',
			'/img/landlords/673f5f1f30a650b1b729e08b_clients_eq-bank.avif',
			'/img/landlords/673f5f1fd34d7db3c100b01b_clients_wealthsimple.avif',
			'/img/landlords/673f5f1fed288f92c5877e58_clients_propel.avif',
			'/img/landlords/673f5f20a0ca48ad592ab083_clients_national-bank.avif',
			'/img/landlords/673f5f204b5096e890ef3f37_clients_money-mart.avif',
		],
	},
	icons: {
		// Landlord icons
		fingerprint: '/img/landlords/fingerprint.gif',
		document: '/img/landlords/document.gif',
		person: '/img/landlords/person.gif',
		// Tenant icons
		clock: '/img/home/clock.gif',
		cloud: '/img/home/cloud.gif',
		house: '/img/home/house.gif',
	},
	houses: {
		house1: '/img/house1.png',
		house2: '/img/house2.png',
		house3: '/img/house3.png',
		house4: '/img/house4.png',
	},
	howItWorks: {
		// Landlord steps
		landlordStep1: '/img/landlords/howitworks1.png',
		landlordStep2: '/img/landlords/howitworks2.png',
		landlordStep3: '/img/landlords/howitworks3.png',
		landlordStep4: '/img/landlords/howitworks4.png',
		// Tenant steps
		tenantStep1: '/img/home/howtowork1.png',
		tenantStep2: '/img/home/howtowork2.png',
		tenantStep3: '/img/home/howtowork3.png',
		tenantStep4: '/img/home/howtowork4.png',
	},
	scoreSection: {
		rightImage: '/img/home/score-right-img.png',
	},
	featureSection: {
		trueTenant: '/img/truetenant-feature-main-image.png',
		apply: '/img/apply-feature.gif',
		rent: '/img/rent-feature.gif',
		signature: '/img/signature-feature.gif',
		share: '/img/share-feature.gif',
	},
	testimonialAvatar: {
		avatar1: 'img/testimonial1.png',
		avatar2: 'img/testimonial2.png',
		avatar3: 'img/testimonial3.png',
	},
	platform: {
		tenantScreening: '/img/landlords/platform1.png',
		voiceAgent: '/img/landlords/howitworks1.png',
		rentGuarantee: '/img/landlords/howitworks2.png',
		leaseGenerator: '/img/landlords/howitworks3.png',
		payments: '/img/landlords/platform1.png',
		marketplace: '/img/landlords/platform1.png',
	},
	leasingTeamMemberImage: {
		gradientImage: '/img/home/score-bg.png',
		rightImage: '/img/landlords/leasingTeamMember-right-img.png',
		listItem: '/img/landlords/tick.png',
	},
	arrows: {
		upBlack: '/img/landlords/up-arrow-black.png',
		upWhite: '/img/landlords/up-arrow-white.png',
	},
	differenceSection: {
		icon: {
			tick: '/img/landlords/tick-checkbox.png',
		},
	},
	Footer: {
		bannerImage: '/img/landlords/footer-img.webp',
		logoImage: '/img/TrueTenant.png',
	},
} as const
